import gettext from '@sdk/lang/gettext';

import { PathnameEnum } from '@web/Router/router.types';
import { generatePath } from '@web/Router/router.utils';

import { useQuickSearch } from './quickSearch.hooks';
import {
  InnerWrapper,
  Input,
  List,
  ListItem,
  ListItemLink,
  OuterWrapper,
} from './quickSearch.styles';

export const QuickSearch = () => {
  const {
    listRef,
    onItemClick,
    onQueryChange,
    state: { activeConversation, filteredItems, isOpen, query },
    setActiveElement,
  } = useQuickSearch();

  return isOpen ? (
    <OuterWrapper>
      <InnerWrapper>
        <Input
          autoFocus={true}
          onChange={onQueryChange}
          placeholder={gettext('Start typing conversation name...')}
          value={query}
        />
        <List ref={listRef}>
          {filteredItems.map((conversation) => (
            <ListItem
              ref={activeConversation === conversation ? setActiveElement : undefined}
              isSelected={activeConversation === conversation}
              key={conversation.id}>
              <ListItemLink
                onClick={onItemClick}
                to={generatePath(PathnameEnum.CONVERSATION_DETAILS, {
                  params: {
                    id: conversation.id,
                    slug: conversation.slug,
                  },
                })}>
                {conversation.name}
              </ListItemLink>
            </ListItem>
          ))}
        </List>
      </InnerWrapper>
    </OuterWrapper>
  ) : null;
};
